(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lk-sage-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lk-hero-motion')) {
  customElements.define('lk-hero-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      let requested = false;
      video.muted = true;
      button.hidden = false;
      const update = () => {
        button.textContent = video.paused ? this.dataset.play : this.dataset.pause;
        this.classList.toggle('is-playing', !video.paused);
      };
      const play = () => {
        if (!video.getAttribute('src')) { video.src = video.dataset.src; video.load(); }
        video.play().catch(update);
      };
      video.addEventListener('playing', () => { this.classList.add('has-played'); update(); });
      video.addEventListener('pause', update);
      video.addEventListener('error', () => { this.classList.remove('has-played'); update(); });
      button.addEventListener('click', () => { requested = true; video.paused ? play() : video.pause(); });
      const begin = () => {
        this.dataset.motionPolicy = navigator.connection?.saveData ? 'save-data' : 'autoplay';
        if (!this.isConnected || requested || navigator.connection?.saveData) return;
        play();
      };
      const poster = this.querySelector('img');
      const schedule = () => {
        if ('requestIdleCallback' in window) window.requestIdleCallback(begin, { timeout: 1500 });
        else setTimeout(begin, 500);
      };
      if (poster.complete) schedule();
      else { poster.addEventListener('load', schedule, { once: true }); poster.addEventListener('error', schedule, { once: true }); }
    }
  });
}
function initLondonScrollReveals(root = document) {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const targets = root.querySelectorAll('.lk-section-heading,.lk-product,.lk-category,.lk-story .lk-copy,.lk-story .lk-hero-image,.lk-service article');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.dataset.reveal = 'visible';
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
  targets.forEach(target => {
    if (target.dataset.reveal || target.getBoundingClientRect().top < window.innerHeight) return;
    target.classList.add('lk-scroll-reveal');
    target.dataset.reveal = 'waiting';
    observer.observe(target);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initLondonScrollReveals(), { once: true });
else initLondonScrollReveals();
document.addEventListener('shopify:section:load', event => initLondonScrollReveals(event.target));

  } catch(e) { console.error(e); }
})();
})();
